if (!customElements.get('product-modal')) {
  const activateImage = (image) => {
    image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    delete image.dataset.srcset;
    delete image.dataset.src;
  };

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.openedBy = opener;
        // DOM writes go first, while the dialog is still closed; the focus move inside super.show() is then the
        // only layout pass, and the reads in showActiveMedia() reuse it.
        const activeMedia = this.setActiveMedia();
        super.show(opener);
        this.showActiveMedia(activeMedia);

        // The other images keep native lazy loading; wire their sources after the opened dialog has painted.
        requestAnimationFrame(() => setTimeout(() => this.querySelectorAll('img[data-src]').forEach(activateImage)));
      }

      setActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        activeMedia.classList.add('active');

        // Only the opened media requests its source now (images are decoding="async").
        if (activeMedia.nodeName === 'IMG') {
          activeMedia.loading = 'eager';
          if (activeMedia.dataset.src) activateImage(activeMedia);
        } else {
          activeMedia.querySelectorAll('img[data-src]').forEach(activateImage);
        }
        return activeMedia;
      }

      showActiveMedia(activeMedia) {
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    },
  );
}
